import { useDocumentTitle, useMe } from '../app/context.js';
import { IconArrowRight, IconWarning } from '../components/icons.js';

function greeting(): string {
  const h = Number(new Date().toLocaleString('de-DE', { hour: '2-digit', hour12: false, timeZone: 'Europe/Berlin' }));
  return h < 11 ? 'Guten Morgen' : h < 18 ? 'Hallo' : 'Guten Abend';
}

/** Start: eine Kachel je Tool, das der Betrieb gebucht hat und für das der Nutzer eine Rolle hat. Klick öffnet das Tool (SSO). */
export function HomePage() {
  useDocumentTitle('Start');
  const me = useMe().data!;
  const firstName = me.name?.split(' ')[0];

  return (
    <main className="page">
      <header className="hero page__head--stack">
        <span className="hero__dot hero__dot--1" aria-hidden="true" />
        <span className="hero__dot hero__dot--2" aria-hidden="true" />
        <span className="hero__dot hero__dot--3" aria-hidden="true" />
        <span className="eyebrow">{me.tenant?.name ?? 'Betriebsam'}</span>
        <h1 className="page__title">
          <span className="mute">{greeting()}{firstName ? ',' : ''}</span>
          {firstName && (
            <>
              <br />
              {firstName}
            </>
          )}
        </h1>
      </header>

      {me.tenant && me.tenant.status !== 'active' && (
        <div className="alert alert--warn" role="alert">
          <IconWarning />
          <div>
            <strong>Der Betrieb ist gesperrt.</strong> Die Tools sind vorübergehend nicht verfügbar. Bitte wende dich an das Betriebsam-Team.
          </div>
        </div>
      )}

      {me.tiles.length > 0 ? (
        <section className="tiles" aria-label="Deine Tools">
          {me.tiles.map((t) => (
            <a key={t.appId} className="tile" href={t.url}>
              <span className="tile__mark" aria-hidden="true">{t.name.slice(0, 1)}</span>
              <span className="tile__body">
                <strong className="tile__name">{t.name}</strong>
                <span className="tile__desc">{t.description}</span>
                <span className="badges">
                  {t.roleLabels.map((r) => (
                    <span key={r} className="badge badge--info">{r}</span>
                  ))}
                </span>
              </span>
              <IconArrowRight className="tile__arrow" />
            </a>
          ))}
        </section>
      ) : (
        me.tenant?.status === 'active' && (
          <div className="empty">
            <strong>Noch keine Tools</strong>
            <p>
              {me.tenantAdmin
                ? 'Weise dir oder deinem Team unter „Team“ Rollen für die freigeschalteten Tools zu.'
                : 'Dir sind noch keine Tools zugewiesen. Die Administration deines Betriebs kann das unter „Team“ ändern.'}
            </p>
          </div>
        )
      )}

      {!me.tenant && !me.platformAdmin && (
        <div className="empty">
          <strong>Kein Betrieb zugeordnet</strong>
          <p>Dein Konto ist noch keinem Betrieb zugeordnet. Bitte wende dich an das Betriebsam-Team.</p>
        </div>
      )}
    </main>
  );
}
